module.exports = __webpack_public_path__ + "img/SC-7799.fbe2a9f2.png";